import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

const failed = () => {};

export default (user, cb) => Vue.$http
  .patch(`users/${encodePathSegment(user.id)}`, user)
    .then((res) => {
      cb(null, res);
    })
    .catch(failed);



// WEBPACK FOOTER //
// ./src/services/user/edit.js